import { KeyPair, keyStores } from 'near-api-js';
import getConfig from './config';

// Earlier builds copied Sender's access key (including its secret key) and
// Orderly trading keys into localStorage. Delete anything they left behind.
const LEGACY_KEY_ENTRIES = [
  'REF_FI_SENDER_WALLET_ACCESS_KEY',
  'REF_ORDERLY_NORMALIZED_KEY',
  'REF_ORDERLY_ACCOUNT_VALID',
  'orderly-trading-key-private:testnet',
  'orderly-trading-key-private:mainnet',
  'orderly-trading-key-public:testnet',
  'orderly-trading-key-public:mainnet',
];

export const purgeLegacyKeyStorage = () => {
  LEGACY_KEY_ENTRIES.forEach((key) => {
    try {
      localStorage.removeItem(key);
    } catch (error) {}
  });
};

export const getSelectedWalletId = () => {
  return window.selector.store.getState().selectedWalletId;
};

// Reads the public half of the function-call key the selected wallet keeps
// for this app. Never copies key material anywhere.
export const getPublicKey = async (
  accountId: string
): Promise<string | undefined> => {
  const networkId = getConfig().networkId;
  const selectedWalletId = getSelectedWalletId();

  if (selectedWalletId === 'sender') {
    // @ts-ignore
    return window?.near?.authData?.accessKey?.publicKey;
  }

  if (selectedWalletId === 'near-mobile-wallet') {
    const storage = JSON.parse(
      localStorage.getItem('near-mobile-signer:session') || '{}'
    );
    const privateKey =
      storage?.[networkId]?.accounts?.[storage?.[networkId]?.activeAccount];
    return privateKey
      ? KeyPair.fromString(privateKey).getPublicKey().toString()
      : undefined;
  }

  const prefix =
    selectedWalletId === 'meteor-wallet'
      ? '_meteor_wallet'
      : selectedWalletId === 'keypom'
      ? 'keypom:'
      : undefined;
  const keyStore = new keyStores.BrowserLocalStorageKeyStore(
    window.localStorage,
    prefix
  );
  return (await keyStore.getKey(networkId, accountId))
    ?.getPublicKey()
    ?.toString();
};
